import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SiteConfigService } from '../core/site-config.service';

@Component({
  selector: 'app-live-page',
  template: `
    <section class="page-card">
      <p class="eyebrow">Canli Yayin</p>
      <h1>Live #{{ liveID }}</h1>
      <p>Socket yolu: {{ site.config().socketUrl }}</p>
      <p>Bu rota izleyici ekranini ve realtime chat/gift/reaction katmanini tasiyacak.</p>
    </section>
  `
})
export class LivePage {
  private readonly route = inject(ActivatedRoute);
  protected readonly site = inject(SiteConfigService);
  protected readonly liveID = this.route.snapshot.paramMap.get('id') ?? '';
}
